import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './lib/fontawesome';
import './styles/index.css';

const container = document.getElementById('root');

if (!container) {
  throw new Error('No se encontro el elemento #root en index.html.');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
